module.exports = __webpack_public_path__ + "img/BQ-SA.6d3a84b6.svg";